var _ellipse, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 16.5,
    rx: 16,
    ry: 16.5,
    fill: "#514EF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5086 25.125C9.57528 25.125 8.98362 24.8083 8.60862 24.4333C7.87528 23.7 7.35862 22.1416 9.00862 18.8333L9.73362 17.3916C9.82528 17.2 9.82528 16.8 9.73362 16.6083L9.00862 15.1666C7.35028 11.8583 7.87528 10.2916 8.60862 9.56662C9.33362 8.83329 10.9003 8.30829 14.2003 9.96662L21.3336 13.5333C23.1086 14.4166 24.0836 15.65 24.0836 17C24.0836 18.35 23.1086 19.5833 21.3419 20.4666L14.2086 24.0333C12.5919 24.8416 11.3919 25.125 10.5086 25.125ZM10.5086 10.125C10.0586 10.125 9.70862 10.2333 9.49195 10.45C8.88362 11.05 9.12528 12.6083 10.1253 14.6L10.8503 16.05C11.1169 16.5916 11.1169 17.4083 10.8503 17.95L10.1253 19.3916C9.12528 21.3916 8.88362 22.9416 9.49195 23.5416C10.0919 24.15 11.6503 23.9083 13.6503 22.9083L20.7836 19.3416C22.0919 18.6916 22.8336 17.8333 22.8336 16.9916C22.8336 16.15 22.0836 15.2916 20.7753 14.6416L13.6419 11.0833C12.3753 10.45 11.2836 10.125 10.5086 10.125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0332 17.625H10.5332C10.1915 17.625 9.9082 17.3417 9.9082 17C9.9082 16.6583 10.1915 16.375 10.5332 16.375H15.0332C15.3749 16.375 15.6582 16.6583 15.6582 17C15.6582 17.3417 15.3749 17.625 15.0332 17.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.d16a17c1975037f63c581cca2fe4f789.svg";
export { ForwardRef as ReactComponent };